module.exports = __webpack_public_path__ + "fonts/BarlowCondensed-Black.8ea3199.woff2";